module.exports = __webpack_public_path__ + "05_glasses_brown.1dca3e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/05_glasses_brown.png
// module id = OzG6
// module chunks = 0